import { rankingList } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门榜单</h2>
            <p className="text-sm text-foreground-500">全站最受欢迎的热门漫画排行</p>
          </div>
          <div className="space-y-3">
            {rankingList.map((item, i) => (
              <div
                key={i}
                className="flex flex-col sm:flex-row items-start gap-4 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer"
              >
                <div className="flex items-center gap-4 flex-shrink-0">
                  <div
                    className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading text-lg ${
                      i < 3
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    {item.rank}
                  </div>
                  <div className="w-16 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.type}</span>
                  <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed line-clamp-1">{item.desc}</p>
                </div>
                <div className="flex-shrink-0 flex items-center gap-2 self-end sm:self-center">
                  <span className="text-sm font-heading text-primary-500 whitespace-nowrap">{item.heat}</span>
                  <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}